import Repository from "../../repository";

export default {
    UploadBase64: (payload) => Repository.post(`/api/Upload/UploadBase64`, payload),
    GetByID: (payload) => Repository.post(`/api/Upload/GetByID`, payload),
}
